export default "__VITE_ASSET__A1K8n8Q6__"